import React, { FC, useCallback } from 'react';
import { withTooltip } from '../../hoc';
import { Button as ChakraUiButton } from '@chakra-ui/react';
import { ButtonProps } from './types';

export const Button: FC<ButtonProps> = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { data = {}, href, targetBlank, onClick, isFullWidth, ...rest } = props;

  const clickHandler = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      if (href) {
        if (targetBlank) {
          window.open(href, '_blank', 'noopener,noreferrer');
        } else {
          window.location.assign(href);
        }
      }
      onClick?.(e);
    },
    [href, onClick]
  );

  /**
   * DOM
   */
  return (
    <ChakraUiButton
      data-object-type="button"
      ref={ref}
      onClick={clickHandler}
      iconSpacing={'0'}
      {...(href && { as: 'a' })}
      {...(isFullWidth && { width: 'full', flexGrow: '1' })}
      {...rest}
    >
      {props.children}
    </ChakraUiButton>
  );
});

Button.displayName = 'Button';

export default withTooltip('CoreButton')(Button);
